import {
  parseClauseMarker,
  ProcessedClauseTemplate,
} from "./parse_clause_object";
import {RegexClauseData} from "./process_clause_link_template";

export function usePreviousTemplateResults(
  match: string,
  matches: RegexClauseData[],
): ProcessedClauseTemplate {
  const json = parseClauseMarker(match);

  const reference = json.clause_reference || json.clause_reference_general;

  if (!reference) {
    return {hasFailed: true, text: "Clause Unknown"};
  }

  const previousData = matches
    .map(({clauseData}) => clauseData)
    .filter(clauseData => clauseData) as ProcessedClauseTemplate[];

  const newMatch = previousData.find(
    clauseData =>
      !clauseData.hasFailed && clauseData.data.reference === reference,
  );

  return newMatch || {hasFailed: true, text: `Clause ${reference}`};
}
